import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { adminStatisticsReducer } from './reducer/admin-statistics.reducer';
import { AdminStatisticsEffects } from './effects/admin-statistics.effects';
import { AdminStatisticsApiService } from './services/admin-statistics-api.service';
import { ADMIN_STATS_FEATURE_KEY } from './definitions/admin-statistics.definitions';

@NgModule({
  imports: [
    StoreModule.forFeature(ADMIN_STATS_FEATURE_KEY, adminStatisticsReducer),
    EffectsModule.forFeature([AdminStatisticsEffects]),
  ],
  providers: [AdminStatisticsApiService],
})
export class AdminModule {}
